// all routes
import Routes from './routes/Routes';
import Loader from './components/Loader';
import { useEffect, useState } from 'react';

// helpers
import 'react-phone-input-2/lib/style.css';

// For Default import Theme.scss
import './assets/scss/Theme.scss';

const App = () => {
    // const [loading, setLoading] = useState(false);

    // useEffect(() => {
    //     const handleLoader = (e: any) => {
    //         setLoading(e.detail);
    //     };
    //     window.addEventListener('api-loading', handleLoader);
    //     return () => window.removeEventListener('api-loading', handleLoader);
    // }, []);

    return (
        <>
            {/* {loading && <Loader />} */}
            <Routes />
        </>
    );
};

export default App;
